<script lang="ts">import { cfgToThemeCdnPath } from "@infinitro/config";
import { t, Verbiage } from "@infinitro/content";
import { isNotificationsOpen, isPlayerChatOpen, loggedIn, stateRaces, toSiteUrl } from "@infinitro/global";
import TopCard from "./top-card.svelte";
$: hasActiveRaces = (() => {
	const races = $stateRaces ?? [];
	if (races.length === 0) return false;
	const now = new Date();
	return races.some((race) => {
		const startDate = new Date(race.startDate);
		const endDate = new Date(race.endDate);
		return now >= startDate && now <= endDate && race.active;
	});
})();
$: isComingSoon = !hasActiveRaces;
</script>

<a
	href={isComingSoon
		? 'javascript:void(0)'
		: toSiteUrl('/promotion-page/race/flush-races/', $loggedIn)}
>
	<div class="top-card-container">
		<TopCard
			backgroundImage={cfgToThemeCdnPath('/top-section/small-top-right.png')}
			height="100%"
			width="100%"
		/>
		<div class="content-top-card">
			<div class="content-wrapper">
				<div class="card-title">
					<h2 class="card-section-title">
						<span>{$t(Verbiage.races).toUpperCase()}</span>
					</h2>
				</div>
				<div class="description-text">
					<p
						class="card-section-body"
						class:card-section-body-wider={$isPlayerChatOpen || $isNotificationsOpen}
					>
						<span
							>{isComingSoon ? $t(Verbiage.starting_shortly) : $t(Verbiage.races_description)}</span
						>
					</p>
				</div>
			</div>
		</div>
	</div>
</a>

<style>
	a {
		height:
			100%;
		width:
			100%;
}

	@media (min-width: 1280px) {
		a {
				width:
			43%;
		}
	}

	.content-top-card {
		position:
			absolute;
		z-index:
			40;
		display:
			flex;
		height:
			100%;
		width:
			100%;
		align-items:
			center;
		justify-content:
			space-between;
		padding:
			1rem;
}

	.content-wrapper {
		display:
			flex;
		height:
			100%;
		width:
			100%;
		flex-direction:
			column;
		justify-content:
			space-between;
}

	@media (min-width: 1280px) {
		.content-top-card {
				align-items:
			center;
				justify-content:
			space-between;
				padding:
			0.75rem;
		}
	}

	@media (min-width: 1440px) {
		.content-top-card {
				padding:
			1.25rem;
		}
	}

	.top-card-container {
		position:
			relative;
		display:
			flex;
		height:
			100%;
		width:
			100%;
		cursor:
			pointer;
		align-items:
			center;
		justify-content:
			space-between;
}

	@media (min-width: 1280px) {
		.top-card-container img {
				right:
			-15%;
				height:
			110%;
		}
	}

	.description-text {
		width:
			65%;
}

	@media (min-width: 1280px) {
		.description-text {
				width:
			100%;
		}
	}

	@media (min-width: 1440px) {
		.description-text {
				width:
			65%;
		}
	}

	.text-with-shadow {
		text-shadow:
			0px 0px 6px rgba(0, 0, 0, 1),
			0px 0px 3px rgba(0, 0, 0, 1);
	}

	@media (min-width: 640px) {
		.hide-tablet {
				display:
			none;
		}
	}

	@media (min-width: 1280px) {
		.hide-tablet {
				display:
			flex;
		}
	}

	/*
	.hide-mobile {
		@apply w-full hidden flex-col;
	}
	*/

	@media (min-width: 640px) {
		.hide-mobile {
				display:
			flex;
		}
	}

	.card-title {
		display:
			flex;
}

	@media (min-width: 1280px) {
		.card-title {
				justify-content:
			flex-start;
		}
	}

	.card-section-title {
		font-size:
			14px;
		font-weight:
			700;
		--tw-text-opacity:
			1;
		color:
			rgb(255 255 255 / var(--tw-text-opacity, 1));
		font-family:
			var(--font-alternative-2);
}

	@media (min-width: 640px) {
		.card-section-title {
				font-size:
			24px;
		}
	}

	@media (min-width: 1280px) {
		.card-section-title {
				font-size:
			18px;
			font-size: clamp(8px, 1.1cqi, 18px) !important;
		}
	}

	.card-section-body {
		max-width:
			100%;
		font-size:
			9px;
		--tw-text-opacity:
			1;
		color:
			rgb(255 255 255 / var(--tw-text-opacity, 1));
		font-family:
			var(--font-alternative-2);
		text-align: start !important;
		text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.5);
}

	@media (min-width: 640px) {
		.card-section-body {
				max-width:
			95%;
				font-size:
			12px;
			font-size: clamp(8px, 0.8cqi, 12px) !important;
		}
		.card-section-body-wider {
				max-width:
			100%;
		}
	}

	@media (min-width: 1600px) {
		.card-section-body {
				font-size:
			14px;
		}
	}
</style>
